//
// Copyright 2020 DXOS.org
//
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";
import { file_dxos_keys } from "../keys_pb.js";
/**
 * Describes the file dxos/halo/signed.proto.
 */
export const file_dxos_halo_signed = /*@__PURE__*/ fileDesc("ChZkeG9zL2hhbG8vc2lnbmVkLnByb3RvEhBkeG9zLmhhbG8uc2lnbmVkIpMBCghLZXlDaGFpbhIoCgpwdWJsaWNfa2V5GAEgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleRIwCgdtZXNzYWdlGAIgASgLMh8uZHhvcy5oYWxvLnNpZ25lZC5TaWduZWRNZXNzYWdlEisKB3BhcmVudHMYAyADKAsyGi5keG9zLmhhbG8uc2lnbmVkLktleUNoYWluIt0CCg1TaWduZWRNZXNzYWdlEjYKBnNpZ25lZBgBIAEoCzImLmR4b3MuaGFsby5zaWduZWQuU2lnbmVkTWVzc2FnZS5TaWduZWQSPQoKc2lnbmF0dXJlcxgCIAMoCzIpLmR4b3MuaGFsby5zaWduZWQuU2lnbmVkTWVzc2FnZS5TaWduYXR1cmUaTwoGU2lnbmVkEg8KB2NyZWF0ZWQYASABKAkSDQoFbm9uY2UYAiABKAwSJQoHcGF5bG9hZBgKIAEoCzIULmdvb2dsZS5wcm90b2J1Zi5BbnkagwEKCVNpZ25hdHVyZRIhCgNrZXkYASABKAsyFC5keG9zLmtleXMuUHVibGljS2V5EhEKCXNpZ25hdHVyZRgCIAEoDBIyCglrZXlfY2hhaW4YAyABKAsyGi5keG9zLmhhbG8uc2lnbmVkLktleUNoYWluSACIAQFCDAoKX2tleV9jaGFpbmIGcHJvdG8z", [file_google_protobuf_any, file_dxos_keys]);
/**
 * Describes the message dxos.halo.signed.KeyChain.
 * Use `create(KeyChainSchema)` to create a new message.
 */
export const KeyChainSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_signed, 0);
/**
 * Describes the message dxos.halo.signed.SignedMessage.
 * Use `create(SignedMessageSchema)` to create a new message.
 */
export const SignedMessageSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_signed, 1);
/**
 * Describes the message dxos.halo.signed.SignedMessage.Signed.
 * Use `create(SignedMessage_SignedSchema)` to create a new message.
 */
export const SignedMessage_SignedSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_signed, 1, 0);
/**
 * Describes the message dxos.halo.signed.SignedMessage.Signature.
 * Use `create(SignedMessage_SignatureSchema)` to create a new message.
 */
export const SignedMessage_SignatureSchema = /*@__PURE__*/ messageDesc(file_dxos_halo_signed, 1, 1);
//# sourceMappingURL=signed_pb.js.map